import { useState } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { apiClient } from '@/services/core/apiClient';
import { useToast } from '@/hooks/use-toast';

interface AddUserGroupPayload {
  userGroupName: string;
  userIds: number[];
}

export const useAddUserGroup = () => {
  const { user, token } = useAuth();
  const { toast } = useToast();
  const [loading, setLoading] = useState(false);

  const addUserGroup = async (payload: AddUserGroupPayload) => {
    if (!user?.id || !token) {
      throw new Error('User not authenticated');
    }

    setLoading(true);
    try {
      const endpoint = `/api/ngpep/${user.id}/usergroup`;
      const response = await apiClient.post(endpoint, payload, token);

      if (!response.success) {
        throw new Error(response.error || 'Failed to create user group');
      }

      toast({
        title: "User Group Created",
        description: `Successfully created user group "${payload.userGroupName}" with ${payload.userIds.length} users.`,
      });

      return response.data;
    } catch (error: any) {
      toast({
        title: "Error",
        description: error.message || 'Failed to create user group',
        variant: "destructive",
      });
      throw error;
    } finally {
      setLoading(false);
    }
  };

  return { addUserGroup, loading };
};
